import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TOrdersRecognitionSidebarMode } from '@entities/sidebar/model/orders-recognition-sidebar.types';

interface IState {
    mode: TOrdersRecognitionSidebarMode;
}

const initialState: IState = {
    mode: 'closed',
};

const ordersRecognitionSidebarSlice = createSlice({
    name: 'ordersRecognitionSidebar',
    initialState,
    reducers: {
        openFull(state) {
            state.mode = 'full';
        },
        openHalf(state) {
            state.mode = state.mode === 'half' ? 'full' : 'half';
        },
        close(state) {
            state.mode = 'closed';
        },
        toggle(state) {
            state.mode = state.mode === 'closed' ? 'full' : 'closed';
        },
        setMode(state, action: PayloadAction<TOrdersRecognitionSidebarMode>) {
            state.mode = action.payload;
        },
    },
});

export const ordersRecognitionSidebarActions = ordersRecognitionSidebarSlice.actions;
export const ordersRecognitionSidebarReducer = ordersRecognitionSidebarSlice.reducer;

export type TOrdersRecognitionSidebarState = ReturnType<
    typeof ordersRecognitionSidebarSlice.reducer
>;
